<template>
  <div class="file__bottom LKRoadmapsFeedCardFileBottom">
    <label
      :class="{ 'is-disabled': disabled }"
      class="file__button w-inline-block LKRoadmapsFeedCardFileBottom__button"
    >
      <img
        src="/images/i-file.svg"
        loading="lazy"
        alt=""
        class="file__button-img"
      >
      <div class="text-sm-bold mod--button">
        <span>Прикрепить файл</span>
      </div>
      <input
        v-show="false"
        type="file"
        :multiple="settings.size > 1"
        @change="onChange"
      >
    </label>

    <div class="file__bottom-box-text">
      <div class="text-sm">
        <span class="mod--grey">Максимальный размер, количество – </span>
        <nobr>{{ settings.size }}Mb, {{ settings.count }} {{ settings.countLabel }}</nobr>
      </div>

      <div class="text-sm">
        <span class="mod--grey">
          {{
            settings.countType === 1
              ? 'Доступный тип файла – '
              : 'Доступные типы файлов – '
          }}
        </span>

        <span>{{ settings.type }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { declinationLabels, files } from '@/helpers/declinationLabels'
import { isBeforeToday } from '@/helpers/dateFormatter'
import { RoadmapEventStatuses } from '@/typings/api/RoadmapEvent'


export default {
  name: 'LKRoadmapsFeedCardFileBottom',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  computed: {
    settings() {
      const { data } = this.node
      const size = data.max_file_size || 0
      const count = data.max_file_count || 0

      return {
        size,
        count,
        countLabel: declinationLabels(count, files),
        type: data.file_types?.join(', ') || 'любые',
        countType: data.file_types?.length,
      }
    },
    disabled() {
      const { data, children } = this.node
      const { confirmed, expired } = RoadmapEventStatuses

      return (
        children?.length >= this.settings.count
        || (this.isAdresat && data.status === confirmed)
        || (this.isAdresat && data.status === expired && isBeforeToday(data.end_at))
      )
    },
  },
  methods: {
    onChange(e) {
      if (this.disabled) return
      this.$emit('change', [...e.target.files])
      e.target.value = ''
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedCardFileBottom {
  &__button {
    margin-right: 30px;

    &.is-disabled {
      pointer-events: none;
      cursor: default;
      opacity: 0.5;
    }
  }
}
</style>
